import { APPROVE_BILLS_REQUEST, APPROVE_BILLS_SUCCESS, APPROVE_BILLS_FAIL, 
    REJECT_BILLS_REQUEST, REJECT_BILLS_SUCCESS, REJECT_BILLS_FAIL,
    APPROVE_PAYMENTS_REQUEST, APPROVE_PAYMENTS_SUCCESS, APPROVE_PAYMENTS_FAIL,
    REJECT_PAYMENTS_REQUEST, REJECT_PAYMENTS_SUCCESS, REJECT_PAYMENTS_FAIL } from "../types/approvalTypes";
import Axios from 'axios';
import APP_CONSTANT from '../../config/constants';
import cogoToast from 'cogo-toast';

export const approveBills = (approveData) => async (dispatch) => {

    dispatch({ type: APPROVE_BILLS_REQUEST });

    try {
        
        const { data } = await Axios.patch(`${APP_CONSTANT.BASE_URL}purchase/bill/updateBillStatus`, approveData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: APPROVE_BILLS_SUCCESS, payload: data });
        
        if(data.status ===  1 && data.data.failedCount > 0) {
            cogoToast.error(<div>
               <p>{data.data.errorMsg}</p> 
               <p>Success Count: {data.data.successCount}</p>
               <p>Failed Count: {data.data.failedCount}</p>
            </div>, { position: 'top-right'}).then(()=> {
                window.location.reload()  
            })
            
        } else {
            cogoToast.success(<div>
                <p>{data.message}</p> 
                <p>Success Count: {data.data.successCount}</p>
                <p>Failed Count: {data.data.failedCount}</p>
             </div>,{ position: 'top-right'}).then(()=> {
                 window.location.reload()  
             }) 
        }
            
    } catch (error) {   
        dispatch({ type: APPROVE_BILLS_FAIL, payload: error.message })
    }
}

export const rejectBills = (rejectData) => async (dispatch) => {

    dispatch({ type: REJECT_BILLS_REQUEST });

    try {

        const { data } = await Axios.patch(`${APP_CONSTANT.BASE_URL}purchase/bill/updateBillStatus`, rejectData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: REJECT_BILLS_SUCCESS, payload: data });
        
        if(data.status ===  1 && data.data.failedCount > 0) {
            cogoToast.error(<div>
               <p>{data.data.errorMsg}</p> 
               <p>Success Count: {data.data.successCount}</p>
               <p>Failed Count: {data.data.failedCount}</p>
            </div>, { position: 'top-right'}).then(()=> {
                window.location.reload()  
            })
            
        } else {
            cogoToast.success(<div>
                <p>{data.message}</p> 
                <p>Success Count: {data.data.successCount}</p>
                <p>Failed Count: {data.data.failedCount}</p>
             </div>, { position: 'top-right'}).then(()=> {
                 window.location.reload()  
             }) 
        }
            
    } catch (error) {   
        dispatch({ type: REJECT_BILLS_FAIL, payload: error.message })
    }
}

export const approvePayments = (approveData) => async (dispatch) => {

    dispatch({ type: APPROVE_PAYMENTS_REQUEST });

    try {

        const { data } = await Axios.patch(`${APP_CONSTANT.BASE_URL}purchase/payment/updatePaymentStatus`, approveData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: APPROVE_PAYMENTS_SUCCESS, payload: data });

        if(data.status ===  1 && data.data.failedCount > 0) {
            cogoToast.error(<div>
               <p>{data.data.errorMsg}</p> 
               <p>Success Count: {data.data.successCount}</p>
               <p>Failed Count: {data.data.failedCount}</p>
            </div>, { position: 'top-right'}).then(()=> {
                window.location.reload()  
            })
            
        } else {
            cogoToast.success(<div>
                <p>{data.message}</p> 
                <p>Success Count: {data.data.successCount}</p>
                <p>Failed Count: {data.data.failedCount}</p>
             </div>, { position: 'top-right'}).then(()=> {
                 window.location.reload()  
             }) 
        }
       
                
    } catch (error) {   
        dispatch({ type: APPROVE_PAYMENTS_FAIL, payload: error.message })
    }
}

export const rejectPayments = (rejectData) => async (dispatch) => {

    dispatch({ type: REJECT_PAYMENTS_REQUEST });

    try {

        const { data } = await Axios.patch(`${APP_CONSTANT.BASE_URL}purchase/payment/updatePaymentStatus`, rejectData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: REJECT_PAYMENTS_SUCCESS, payload: data });

        if(data.status ===  1 && data.data.failedCount > 0) {
            cogoToast.error(<div>
               <p>{data.data.errorMsg}</p> 
               <p>Success Count: {data.data.successCount}</p>
               <p>Failed Count: {data.data.failedCount}</p>
            </div>, { position: 'top-right'}).then(()=> {
                window.location.reload()  
            })
            
        } else {
            cogoToast.success(<div>
                <p>{data.message}</p> 
                <p>Success Count: {data.data.successCount}</p>
                <p>Failed Count: {data.data.failedCount}</p>
             </div>, { position: 'top-right'}).then(()=> {
                 window.location.reload()  
             }) 
        }
                
    } catch (error) {   
        dispatch({ type: REJECT_PAYMENTS_FAIL, payload: error.message })
    }
}